import NewLeadNotificationModal from './NewLeadNotificationModal';

export default NewLeadNotificationModal;
